import React from 'react';

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-[#111111] flex flex-col items-center justify-center p-8">
      {/* Logo */}
      <div className="mb-16 relative">
        {/* Glow effect */}
        <div 
          className="absolute inset-0 animate-float"
          style={{
            background: 'radial-gradient(circle, rgba(139,0,0,0.4) 0%, rgba(139,0,0,0) 70%)',
            transform: 'scale(1.2)',
            filter: 'blur(20px)'
          }}
        />
        
        <img 
          src="https://i.postimg.cc/fJxNP8LM/lc-logo.png"
          alt="Cardinals Logo"
          className="w-48 h-48 object-contain relative animate-float"
        />
      </div>

      {/* Content */}
      <div className="text-center max-w-2xl">
        <h1 className="text-4xl font-light text-white tracking-wide mb-8">
          Site Under Maintenance
        </h1>
        
        <p className="text-base text-gray-400 font-light tracking-wide leading-relaxed mb-16">
          We're currently updating the Lincoln County Cardinals website to bring you an even better experience. Please check back soon!
        </p>

        <div className="text-gray-500 font-light">
          <p className="text-sm tracking-wide mb-2">For immediate assistance, please contact us at:</p>
          <a 
            href="mailto:gobirds@lincolncountycardinals.com"
            className="text-[#8B0000] hover:text-[#A00000] transition-colors text-sm tracking-wide"
          >
            gobirds@lincolncountycardinals.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;